export default __webpack_public_path__ + "31ec95d511c866857b4e1e5bb9e3a1cb.png";